exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-enter-active[data-v-6657fdb2],\n.list-leave-active[data-v-6657fdb2] {\n  -webkit-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n}\n.list-enter[data-v-6657fdb2],\n.list-leave-to[data-v-6657fdb2] {\n  opacity: 0;\n}\n.listContent[data-v-6657fdb2] {\n  height: auto;\n  width: 100%;\n}\n.listContent .commentBox[data-v-6657fdb2] {\n  width: 100%;\n  overflow: hidden;\n}\n.listContent .responEmptyStyle[data-v-6657fdb2] {\n  width: 100%;\n  padding: 24px;\n  text-align: center;\n  color: #ccc;\n  font-size: 12px;\n}\n", ""]);

// exports
